




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { QRcodeLayer } from "@/model/document2/page/surface/design/layer/QRcodeLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

const isElement = (x: any): x is HTMLTextAreaElement =>
  x instanceof HTMLTextAreaElement;

@Component({
  components: {
    DropdownList,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class QRcodeStyle extends Vue {
  @Prop()
    private layer!: QRcodeLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private onFocusInput()
    {
        this.changeInputMode(1);
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    qrcodeStyleContentsOpenAnimate = false;
    qrcodeStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.qrcodeStyleContentsCloseAnimate = true;
        setTimeout(() => {
            this.qrcodeStyleContentsCloseAnimate = false;
            this.qrcodeStyleContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.qrcodeStyleContentsOpenAnimate = true;
        setTimeout(() => {
            this.qrcodeStyleContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓バーコード文字列↓↓↓↓
    get text(): string {
        return this.layer.text;
    }

    confirmText(){
        if (!isElement(this.$refs.textarea)) return;
        this.$refs.textarea.blur()
    }

    //↑↑↑↑↑バーコード文字列↑↑↑↑↑

    //↓↓↓↓↓誤り訂正↓↓↓↓↓
    get errorCorrection(): number {
        return this.layer.errorCorrection;
    }

    isErrorCorrectionDropdownVisible = false;
    private get errorCorrectionDropdownItems() {
        var items = new Array();
            items.push({
            id: 0,
            isSelected: this.errorCorrection == 0,
            label: "L(7%)"
        });
        items.push({
            id: 1,
            isSelected: this.errorCorrection == 1,
            label: "M(15%)"
        });
        items.push({
            id: 2,
            isSelected: this.errorCorrection == 2,
            label: "Q(25%)"
        });
        items.push({
            id: 3,
            isSelected: this.errorCorrection == 3,
            label: "H(30%)"
        });
        return items;
  }
  //↑↑↑↑↑誤り訂正↑↑↑↑↑

    //↓↓↓↓↓バージョン↓↓↓↓↓
    get version(): number {
        return this.layer.version;
    }

    isVersionDropdownVisible = false;
    private get versionDropdownItems() {
        var items = new Array();

        items.push({
            id: 0,
            isSelected: this.version == 0,
            label: "指定なし"
        })

        for(var i = 1; i < 41; i++){
            items.push({
            id: i,
            isSelected: this.version == i,
            label: i
            });
        }
        
        return items;
    }
    //↑↑↑↑↑バージョン↑↑↑↑↑

    //↓↓↓↓↓バージョン↓↓↓↓↓
    get margin(): boolean {
        return this.layer.margin;
    }
    private changeMargin() {
        var newValue = this.layer.margin == true ? false : true;
        this.changeLayerProperty(newValue, "margin");
    }
    //↑↑↑↑↑バージョン↑↑↑↑↑

    private setType(value: number, propertyName: string) {

        this.isErrorCorrectionDropdownVisible = false;
        this.isVersionDropdownVisible = false;

        this.changeLayerProperty(value, propertyName);
    }

    private onSetText(value : any, isFinish : boolean = true)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "text", isFinish);
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false) 
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
